import React, { Component } from "react";
import PropTypes from "prop-types";
import { format } from "d3-format";

import GenericChartComponent from "../GenericChartComponent";
import displayValuesFor from "./displayValuesFor";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor } from "../utils";

class TRIXTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const {
      origin: originProp,
      className,
      fontFamily,
      fontSize,
      labelFill,
      valueFill,
      yDisplayFormat,
      displayValuesFor: displayValuesForProp,
      yAccessor,
      onClick,
      options,
    } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    const currentItem = displayValuesForProp(this.props, moreProps);
    const value = currentItem ? yAccessor(currentItem) : undefined;
    const displayValue =
      value !== undefined && value !== null ? yDisplayFormat(value) : "n/a";

    const period = options?.period ?? options?.windowSize;
    const labelSuffix = period ? ` (${period})` : "";

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-trix"
      >
        <ToolTipText fontFamily={fontFamily} fontSize={fontSize} x={0} y={0}>
          <ToolTipTSpanLabel
            fill={labelFill}
          >{`TRIX${labelSuffix}: `}</ToolTipTSpanLabel>
          <tspan fill={valueFill}>{displayValue}</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

TRIXTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  labelFill: PropTypes.string,
  valueFill: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  yDisplayFormat: PropTypes.func,
  displayValuesFor: PropTypes.func,
  onClick: PropTypes.func,
  options: PropTypes.object,
};

TRIXTooltip.defaultProps = {
  origin: [0, 0],
  className: "react-stockcharts-tooltip",
  fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
  fontSize: 11,
  labelFill: "#4682B4",
  valueFill: "#000000",
  yDisplayFormat: format(".4f"),
  displayValuesFor,
  onClick: undefined,
  options: undefined,
};

export default TRIXTooltip;
